<template>
  <section class="images-cta-container">
    <Button data-testid="similar-items-button" :variant="'secondary'" :expanded="!isMobile" :size="isMobile && 'small'" @click="handleSimilarItems">
      More like this
    </Button>
  </section>
</template>

<script setup>
import Button from '@atomic-ui/button/Button';
import { defineAsyncComponent } from 'vue';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useSlideout } from '~/composables/utils/useSlideout';
import once from '~/utils/once';
import { tagImageMoreLikeClicked } from '~/features/analytics/image';

const { isMobile } = useDeviceType();
const { productId, productData } = useProduct();
const slideoutSimilarItemsComponent = defineAsyncComponent(
  () => import(/* webpackChunkName: "SimilarItemsDrawer" */ /* webpackPrefatch: true */ '~/components/slideoutContent/SimilarItemsSlideout'),
);

const props = defineProps({
  currentPage: {
    type: Number,
    default: 1,
  },
});

function handleSimilarItems() {
  const { showSlideout } = useSlideout();

  showSlideout({
    id: 'similar-items-slideout',
    title: 'Similar items',
    component: slideoutSimilarItemsComponent,
    backable: false,
    position: 'bottom',
    props: {
      product: productData,
      productId,
    },
  });
  /**
   * @param {number} page
   */
  const fireAnalytics = once((page) => tagImageMoreLikeClicked(page));
  fireAnalytics(props.currentPage);
}
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.images-cta-container {
  position: absolute;
  bottom: rem-calc(36);
  right: rem-calc(16);
  z-index: 10;

  @include breakpoint(medium up) {
    bottom: rem-calc(24);
    transform: translateX(50%);
    right: 50%;
    width: 46%;
    max-width: rem-calc(335);
  }
}
</style>
